var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommeticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.33068C0 4.7647 5.96046e-08 3.48172 0.508632 2.50164C0.956048 1.63954 1.66996 0.938636 2.54805 0.499368C3.5463 -1.78814e-07 4.85309 0 7.46667 0H13.5333C16.1469 0 17.4537 -1.78814e-07 18.452 0.499368C19.33 0.938636 20.0439 1.63954 20.4913 2.50164C21 3.48172 21 4.7647 21 7.33068V8.70519C21 11.2712 21 12.5541 20.4913 13.5343C20.0439 14.3963 19.33 15.0972 18.452 15.5365C17.4537 16.0359 16.1469 16.0359 13.5333 16.0359H5.14991C4.8405 16.0359 4.54375 16.1566 4.32496 16.3714L1.99163 18.6622C1.25666 19.3838 0 18.8727 0 17.8523V16.0359V10.3088V7.33068ZM7 4.58168C6.35567 4.58168 5.83333 5.0945 5.83333 5.7271C5.83333 6.35969 6.35567 6.87251 7 6.87251H14C14.6444 6.87251 15.1667 6.35969 15.1667 5.7271C15.1667 5.0945 14.6444 4.58168 14 4.58168H7ZM7 9.16335C6.35567 9.16335 5.83333 9.67616 5.83333 10.3088C5.83333 10.9414 6.35567 11.4542 7 11.4542H10.5C11.1444 11.4542 11.6667 10.9414 11.6667 10.3088C11.6667 9.67616 11.1444 9.16335 10.5 9.16335H7Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommeticon);
export default __webpack_public_path__ + "static/media/commeticon.cd04d1b2aebf44e78f45b06fee388e73.svg";
export { ForwardRef as ReactComponent };